export const PROMO_CATEGORIES_ID = 'PROMO_CATEGORIES';
export const TOP_MENU_PROMOTION_LINK_ID = 'TOP_MENU_PROMOTION_LINK';
